import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

import { DataType, MessageType, MessageTypesEnum } from './types';
import { CHANNEL_NAME } from './constants';

@Injectable({ providedIn: 'root' })
export class FilterTransferService {
  private readonly channel = new BroadcastChannel(CHANNEL_NAME);
  private readonly clipboardData$ = new BehaviorSubject<DataType | null>(null);

  init() {
    // Слушаем сообщения от других вкладок
    this.channel.onmessage = event => {
      const data: MessageType = event.data;
      if (data.type === MessageTypesEnum.FilterCopied) {
        this.clipboardData$.next(data.data);
      }
    };
  }

  copyData(data: DataType): void {
    this.clipboardData$.next(data);
    // отправляем в другие вкладки
    const message: MessageType = {
      type: MessageTypesEnum.FilterCopied,
      data,
    };
    this.channel.postMessage(message);
  }

  getData() {
    return this.clipboardData$.value;
  }
}
